import React, { useState } from 'react';

interface IcoCopyProps {
    refLink: string;
}

export const IcoCopy: React.FC<IcoCopyProps> = ({ refLink }) => {
    const [copied, setCopied] = useState(false);
    const [hover, setHover] = useState(false);

    const handleClick = (text: string) => {
        navigator.clipboard.writeText(text);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const handleMouseEnter = () => {
        setHover(true);
    };

    const handleMouseLeave = () => {
        setHover(false);
    };

    return (
        <button
            onClick={() => handleClick(refLink)}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            style={{
                position: 'relative',
                cursor: 'pointer',
                background: 'none',
                border: 'none',
                outline: 'none',
                opacity: hover ? 0.8 : 1,
            }}
        >
            {copied && (
                <div
                    style={{
                        position: 'absolute',
                        top: '-25px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        fontSize: '12px',
                        color: '#000',
                        backgroundColor: 'rgba(241,241,241,0.68)',
                        borderRadius: '4px',
                        padding: '4px',
                        zIndex: '2',
                    }}
                >
                    Скопировано
                </div>
            )}
            <div
                className="Path1"
                style={{
                    position: 'absolute',
                    left: 1,
                    top: 1,
                    width: '10px',
                    height: '10px',
                    margin: '0 4px 4px 0',
                    opacity: 0.6,
                    borderRadius: 2,
                    backgroundColor: '#f1f1f1',
                    zIndex: '1',
                }}
            ></div>
            <div
                className="Path2"
                style={{
                    width: '10px',
                    height: '10px',
                    margin: '4px 0 0 4px',
                    opacity: 0.6,
                    borderRadius: 2,
                    backgroundColor: '#605f68',
                }}
            ></div>
        </button>
    );
};
